import * as _ from 'lodash';

import { ADD_USERS, REMOVE_USER, RESET_USERS, SET_USERS_LOADING, UserAction } from '@Actions/usersActions';

import { IUserExtension } from '@ClientModels/userExtension';

interface IUsersState {
  users: IUserExtension[];
  usersLoading: boolean;
  usersActiveOrInvited: IUserExtension[]; // this should be deprecated in favor of a memoized selector so users is single source of truth
  usersById: Record<string, IUserExtension>; // this should be deprecated in favor of a memoized selector so users is single source of truth
}

export const defaultState: IUsersState = {
  users: [] as IUserExtension[],
  usersLoading: false,
  usersActiveOrInvited: [] as IUserExtension[],
  usersById: {}
};

export const usersReducer = function (state = defaultState, action: UserAction): IUsersState {
  switch (action.type) {
    case ADD_USERS: {
      const users = _.uniqBy([...action.users, ...state.users], (user) => user.id).map((user) => {
        user.displayName = user.name || user.email;
        return user;
      });
      const usersActiveOrInvited = users.filter((user) => (user.is_active || user.is_invited) && user.user_profile.is_active_or_invited);
      const usersById: Record<string, IUserExtension> = _.keyBy(users, 'id');

      return _.assign({}, state, {
        users,
        usersActiveOrInvited,
        usersById
      });
    }
    case REMOVE_USER: {
      const { [action.user.id]: removedUser, ...newUsersByIdState } = state.usersById;

      return {
        ...state,
        users: state.users.filter((user) => user.id !== action.user.id),
        usersActiveOrInvited: state.usersActiveOrInvited.filter((user) => user.id !== action.user.id),
        usersById: newUsersByIdState
      };
    }
    case SET_USERS_LOADING:
      return {
        ...state,
        usersLoading: action.payload
      };
    case RESET_USERS:
      return { ...defaultState };
    default:
      return state;
  }
};
